export default __webpack_public_path__ + "static/media/bell-icon.802ee76a.svg";